import{responsiveFontSizes as r,createTheme as t}from"@mui/material";var a=function(a){return r(t(a))};export{a as default};
//# sourceMappingURL=createResponsiveTheme.js.map
